function isIOS() {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

function isAndroid() {
  return /android/i.test(navigator.userAgent);
}

function getOS() {
  if (isIOS()) {
    return 'ios';
  } else if (isAndroid()) {
    return 'android';
  } else {
    return '0';
  }
}

// eslint-disable-next-line import/prefer-default-export
export const osType = getOS();
